// TERRAFUSE BACKEND API URL
export const NEW_API_URL = process.env.REACT_APP_API_URL || "https://api.terrafuse.ai/realtimefire/api/v1/";
export const MAPBOX_GEOCODING_API = "https://api.mapbox.com/geocoding/v5/mapbox.places/";
